import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';

import { last, split, groupBy, isEmpty } from 'lodash';
import QRCode from 'qrcode.react';

import DiamondDetailAction from 'components/DiamondDetail/DiamondDetailAction';
import EnquiryDetail from 'components/DiamondDetail/EnquiryDetail';
import DiamondDetailLeft from 'components/DiamondDetail/LeftSection';
import MobileDiamondDetail from 'components/DiamondDetail/MobileDiamondDetail';
import OfferOrder from 'components/DiamondDetail/OfferOrder';
import PlaceOrderDetail from 'components/DiamondDetail/PlaceOrderDetail';
import SimilarStone from 'components/DiamondDetail/SimilarStone';
import { GridHeightContainer } from 'components/GridHeightContainer/GridHeightContainer';
import CommonModal from 'components/common/CommonModal';
import DownloadDropdown from 'components/common/DiamondListing/DownloadDropdown';
import SendEmail from 'components/common/DiamondListing/SendEmail';
import ShareDropdown from 'components/common/DiamondListing/ShareDropdown';
import Heading from 'components/common/Heading';

import { MediaService } from 'services/MediaService';
import Storage from 'services/storage';
import { callApi } from 'services/util';

import IntlMessages from 'util/IntlMessages';
import { withMobile } from 'util/hocs';
import { Notify } from 'util/notify';
import { classNames, formatDecimal, isFunction, isObject } from 'util/utils';

import { getMediaUrl, KYC_STATUS, MEDIA_TYPES, TRACK_TYPES } from 'constants/Common';
import detailView from 'constants/DiamondDetail';
import { VIEW_DIAMOND } from 'constants/apiConstant';

import { handleInsertTrack, LISTINGPAGES, downloadVideo, downloadFile } from '../DiamondList/DiamondListFunctions';
import OpenNotification from '../common/CommonButton/OpenNotification';

import addCartSvg from 'assets/svg/DiamondDetail/add-cart.svg';
import cartSvg from 'assets/svg/DiamondDetail/cart.svg';
import certificateSvg from 'assets/svg/DiamondDetail/certificate.svg';
import downloadZipSvg from 'assets/svg/DiamondDetail/download-zip.svg';
import offerSvg from 'assets/svg/DiamondDetail/offer.svg';
import watchDetailSvg from 'assets/svg/DiamondDetail/watchDetail.svg';
import xRaySvg from 'assets/svg/DiamondDetail/x-ray.svg';
import { ReactComponent as CopyLinkIcon } from 'assets/svg/copylink.svg';
import { ReactComponent as DownloadIcon } from 'assets/svg/download.svg';

let gridHeight = 0;
export function setGridHeightFn() {
  const allContainers = {};
  let totalHeight = window.innerHeight - 15;
  // allContainers.headerHeight = document.getElementsByClassName("headerTopMenu")[0];
  // allContainers.covidStrip = document.getElementsByClassName("covidStrip")[0];
  allContainers.HeaderStripBlock = document.getElementsByClassName('HeaderStripBlock')[0];
  allContainers.diamondDetailBottomBox = document.getElementsByClassName('diamondDetailBottomBox ')[0];
  Object.keys(allContainers).map((key) => {
    if (allContainers[key] && allContainers[key].offsetHeight) {
      totalHeight = totalHeight - allContainers[key].offsetHeight;
    }
    // {console.log(offsetHeight,"height")};
    return true;
  });
  return totalHeight;
}

let gridHeight1 = 0;
export function setGridHeightFn1() {
  const allContainers = {};
  let totalHeight = window.innerHeight - 45;
  allContainers.headerHeight = document.getElementsByClassName('headerTopMenu')[0];
  allContainers.covidStrip = document.getElementsByClassName('covidStrip')[0];
  allContainers.HeaderStripBlock = document.getElementsByClassName('HeaderStripBlock ')[0];
  allContainers.diamondDetailTopTab = document.getElementsByClassName('diamondDetailTopTab')[0];
  Object.keys(allContainers).map((key) => {
    if (allContainers[key] && allContainers[key].offsetHeight) {
      totalHeight = totalHeight - allContainers[key].offsetHeight;
    }
    return true;
  });
  return totalHeight;
}

class DiamondDetail extends React.PureComponent {
  state = {
    visible: false,
    show: false,
    detail: true,
    data: {},
    sendEmail: false,
    gridHeight: 0,
    offer: false,
    visibleEmail: false,
    diamondId: '',
    activeTab: 'tab-main',
    currentSubTab: 0,
    flags: {
      img: true,
      faceUp: true,
      videoFile: true,
      mp4Video: true,
      arrowFile: true,
      hAFile: true,
      certFile: true,
    },
  };

  get data() {
    const { data } = { ...this.state, ...this.props };
    return data;
  }

  get showMp4Video() {
    return true;
  }

  componentDidMount = async () => {
    const id = this.props?.data?.id ?? last(split(window.location.pathname, '/'));
    this.setState({ diamondId: id !== 'diamond-detail' ? id : '' });
    await this.getData(id);

    await this.checkAllFiles();
  };

  componentDidUpdate(prevProps) {
    if (this.props.commonData.strip !== prevProps.commonData.strip) this.forceUpdate();
  }

  placeOrderDetail = () => {
    this.setState({ visible: !this.state.visible, detail: false, show: false, offer: false });
  };

  EnquiryDetail = () => {
    this.setState({ show: !this.state.show, detail: false, visible: false });
  };

  popupClose = () => {
    this.setState({ detail: true, visible: false, show: false, offer: false });
  };

  checkAllFiles = async () => {
    const data = this.data;

    const list = [
      ['img', getMediaUrl(MEDIA_TYPES.JPG_STILL, data?.mfgStnId), true],
      ['faceUp', getMediaUrl(MEDIA_TYPES.JPG_LIGHT_BLACK, data?.mfgStnId), true],
      ['videoFile', getMediaUrl(MEDIA_TYPES.HTML_VIDEO_360, data?.mfgStnId), true],
      ['mp4Video', getMediaUrl(MEDIA_TYPES.MP4_VIDEO_360, data?.vStnId), this.showMp4Video],
      ['arrowFile', getMediaUrl(MEDIA_TYPES.JPG_HEART_BLACK, data?.mfgStnId), true],
      ['hAFile', getMediaUrl(MEDIA_TYPES.JPG_ARROW_BLACK, data?.mfgStnId), true],
      ['certFile', getMediaUrl(MEDIA_TYPES.PDF_LAB_CERT, data?.rptNo), true],
    ];

    const entries = await Promise.all(
      list.map(async ([key, url, show]) => {
        if (!show) return [key, false];
        const headers = await MediaService.getHeaders(url, true);
        return [key, Boolean(headers)];
      }),
    );

    this.setState({ flags: Object.fromEntries(entries) });
  };

  getData = async () => {
    const id = this.props.diamondPopup ? this.data?.id : window.location.pathname.split('/').pop();
    const [, res] = await callApi({ method: VIEW_DIAMOND.method, url: `${VIEW_DIAMOND.url}/${id}` });
    if (res?.code === 'OK') {
      return new Promise((resolve) => this.setState({ data: res.data }, () => resolve()));
    }
  };

  diamondDetail = (data, key) => {
    const grouped = groupBy(data, key);
    let first = grouped[1] || [];
    const second = grouped[2] || [];
    if ((!first || !first.length) && (!second || !second.length)) {
      first = Object.values(grouped)[0];
    }
    const maxIndex = Math.max(first.length, second.length);
    const arr = [];
    for (let i = 0; i < maxIndex; i++) {
      first[i] && arr.push(first[i]);
      second[i] && arr.push(second[i]);
    }
    return arr;
  };

  leftPart = () => {
    return (
      <div className="diamondDetailInnerDetail">
        {isObject(this.data) && (
          <DiamondDetailLeft
            data={this.data}
            flags={this.state.flags}
            activeTab={this.state.activeTab}
            activeTabChange={(tab) => this.setState({ activeTab: tab })}
            currentSubTab={(prev, current) => this.setState({ currentSubTab: current })}
            shared={this.state.shared}
            rptNo={this.data.rptNo}
            pktNo={this.data.vStnId}
          />
        )}
        <div className="d-flex j-content-center downloadCopyLink">
          <div className="diamondDetailSperateBlock commonOutline" onClick={this.handleDownload}>
            <DownloadIcon />
            <span>&nbsp;Download</span>
          </div>
          <div className="diamondDetailSperateBlock commonOutline" onClick={this.handleCopyLink}>
            <CopyLinkIcon />
            <span>&nbsp;Copy Link</span>
          </div>
        </div>
      </div>
    );
  };

  getEmailModal = () => {
    return (
      <SendEmail
        path={`${window.location.origin}/${LISTINGPAGES.DETAIL}/${this.data.id}`}
        sendEmail={this.state.sendEmail}
        onCancel={() => this.setState({ sendEmail: false })}
        onDetailClose={() => this.setState({ sendEmail: false })}
        xRay
      />
    );
  };

  handleCopyLink = () => {
    const { activeTab, data, currentSubTab } = this.state;
    let value = ``;

    if (activeTab === 'tab-video') {
      value = getMediaUrl(MEDIA_TYPES.HTML_VIDEO_360, data?.mfgStnId);
    } else if (activeTab === 'tab-mp4') {
      value = getMediaUrl(MEDIA_TYPES.MP4_VIDEO_360, data?.vStnId);
    } else if (activeTab === 'tab-main') {
      value =
        currentSubTab === 0
          ? getMediaUrl(MEDIA_TYPES.JPG_STILL, data?.mfgStnId)
          : getMediaUrl(MEDIA_TYPES.JPG_LIGHT_BLACK, data?.mfgStnId);
    } else if (activeTab === 'tab-hna') {
      value =
        currentSubTab === 0
          ? getMediaUrl(MEDIA_TYPES.JPG_ARROW_BLACK, data?.mfgStnId)
          : getMediaUrl(MEDIA_TYPES.JPG_HEART_BLACK, data?.mfgStnId);
    } else if (activeTab === 'tab-cert') {
      value = getMediaUrl(MEDIA_TYPES.PDF_LAB_CERT, data?.rptNo);
    }

    navigator.clipboard.writeText(value);
    return Notify.success({ message: 'Link Copied.' });
  };

  handleDownload = () => {
    const { activeTab, data, currentSubTab } = this.state;

    if (activeTab === 'tab-video') {
      MediaService.downloadFile(getMediaUrl(MEDIA_TYPES.MP4_VIDEO_360, data?.vStnId), `video-${data.mfgStnId}.mp4`);
    } else if (activeTab === 'tab-mp4') {
      MediaService.downloadFile(getMediaUrl(MEDIA_TYPES.MP4_VIDEO_360, data?.vStnId), `video-${data.vStnId}.mp4`);
    } else if (activeTab === 'tab-main') {
      downloadFile({
        path:
          currentSubTab === 0
            ? getMediaUrl(MEDIA_TYPES.JPG_STILL, data?.mfgStnId)
            : getMediaUrl(MEDIA_TYPES.JPG_LIGHT_BLACK, data?.mfgStnId),
        fileName: currentSubTab === 0 ? `still-${data.mfgStnId}` : `light_black-${data.mfgStnId}`,
        ext: '.jpg',
      });
    } else if (activeTab === 'tab-hna') {
      downloadFile({
        path:
          currentSubTab === 0
            ? getMediaUrl(MEDIA_TYPES.JPG_ARROW_BLACK, data?.mfgStnId)
            : getMediaUrl(MEDIA_TYPES.JPG_HEART_BLACK, data?.mfgStnId),
        fileName: currentSubTab === 0 ? `Arrow-${data.mfgStnId}` : `hA-${data.mfgStnId}`,
        ext: '.jpg',
      });
    } else if (activeTab === 'tab-cert') {
      downloadFile({
        path: getMediaUrl(MEDIA_TYPES.PDF_LAB_CERT, data?.rptNo),
        fileName: `certi-${data.rptNo}`,
        ext: '.pdf',
      });
    }
  };

  render() {
    const { visibleEmail } = this.state;

    const user = Storage.get('user') ?? {};
    const permission = this.props.commonData.pagePermission()['searchResult'];
    const isCustomer = [4, 10].includes(user?.type);

    const message = isEmpty(user)
      ? 'Register yourself to access the functionality.'
      : isCustomer && !user?.account?.isKycUploaded
      ? 'Please complete your KYC procedure to access the functionality.'
      : isCustomer && user?.account?.isApproved === KYC_STATUS.PENDING
      ? 'Please wait to access the functionality untill your KYC documents get verify.'
      : isCustomer && user?.account?.isApproved === KYC_STATUS.REJECT
      ? 'Your KYC is rejected. Please upload your KYC again with right information'
      : undefined;

    const show3Ex = this.data?.cutNm === 'EX' && this.data?.polNm === 'EX' && this.data?.symNm === 'EX';

    gridHeight = setGridHeightFn();
    gridHeight1 = setGridHeightFn1();

    const params = Object.values(detailView).map((section, index) => (
      <div key={index} className="diamondDetailMore">
        <h2 className="detailSmallTitle">{section?.name}</h2>
        <div className="diamondDetailMoreHalf">
          {Object.values(groupBy(section?.data, 'part')).map((list) => {
            return list.map((field, index) => {
              return (
                <ul key={index}>
                  <li>
                    <span>{field.label}</span>
                    <span>
                      {isFunction(field?.render)
                        ? field?.render(this.data[field?.key], this.data)
                        : field?.isFormat
                        ? formatDecimal(this.data[field?.key])
                        : this.data[field?.key === 'colNm' ? (this.data.isFcCol ? 'fcColDesc' : 'colNm') : field?.key]
                        ? field.key === 'cutNm'
                          ? show3Ex
                            ? this.data[field?.key]
                            : this.data[field?.key]
                          : field.key === 'colNm' && this.data.isFcCol
                          ? this.data.fcColDesc
                          : this.data[field?.key]
                        : '-'}
                    </span>
                  </li>
                </ul>
              );
            });
          })}
        </div>
      </div>
    ));

    if (this.props.isMobile) {
      return <MobileDiamondDetail params={params} {...this.state} parent={this} />;
    }

    return (
      <div className="diamondDetailWrapper">
        <div className="qrCodeOption">
          <QRCode
            size={50}
            value={
              !this.props.diamondPopup
                ? window.location.href
                : `${window.location.origin}/diamond-detail/${this.data.vStnId}`
            }
            level={'L'}
          />
          <span>QR Code</span>
        </div>

        <div className="diamondDetailInner">
          {this.props.diamondPopup && (
            <div className="diamondDetailBottomBox">
              <div className="diamondDetailBottomAction">
                <div className="d-flex">
                  {!this.props.noDetailAction && (
                    <>
                      <DiamondDetailAction
                        image={cartSvg}
                        tooltip="Place Order"
                        placement="bottomLeft"
                        onClick={() => {
                          permission && permission.insert
                            ? this.setState({ visible: true, detail: false, show: false, offer: false })
                            : OpenNotification({ type: 'error', title: message });
                        }}
                      />
                      <DiamondDetailAction
                        image={addCartSvg}
                        tooltip="Add To Cart"
                        placement="bottomLeft"
                        onClick={() => {
                          permission && permission.insert
                            ? handleInsertTrack(TRACK_TYPES.CART, [this.data])
                            : OpenNotification({ type: 'error', title: message });
                        }}
                      />
                      <DiamondDetailAction
                        image={watchDetailSvg}
                        tooltip="Add To Watchlist"
                        placement="bottomLeft"
                        onClick={() => {
                          permission && permission.insert
                            ? handleInsertTrack(TRACK_TYPES.WATCHLIST, [this.data])
                            : OpenNotification({ type: 'error', title: message });
                        }}
                      />
                      <DiamondDetailAction
                        image={offerSvg}
                        tooltip="Apply Offer"
                        placement="bottomLeft"
                        onClick={() => {
                          permission && permission.insert
                            ? this.setState({ offer: true, visible: false, detail: false, show: false })
                            : OpenNotification({ type: 'error', title: message });
                        }}
                      />
                    </>
                  )}

                  <DiamondDetailAction
                    onClick={() => window.open(`https://gia.edu/report-check?reportno=${this.data.rptNo}`)}
                    image={certificateSvg}
                    tooltip="Verify Certificate"
                    placement="bottomLeft"
                  />

                  <DiamondDetailAction
                    onClick={() => {
                      permission && permission.mailExcel
                        ? this.setState({ sendEmail: !this.state.sendEmail })
                        : OpenNotification({ type: 'error', title: message });
                    }}
                    image={xRaySvg}
                    tooltip="Share"
                    placement="bottomLeft"
                  />

                  <DiamondDetailAction
                    onClick={() => {
                      permission && permission.downloadExcel
                        ? this.setState({ visibleEmail: true })
                        : OpenNotification({ type: 'error', title: message });
                    }}
                    image={downloadZipSvg}
                    tooltip="Download Zip"
                    placement="bottomLeft"
                  />
                </div>
              </div>
            </div>
          )}

          <div className="diamondDetailMainTab">
            <GridHeightContainer
              className="diamondDetailLeft"
              subtractFrom=".diamondDetailInner > .diamondDetailBottomBox"
            >
              <GridHeightContainer className="diamondDetailInnerDetail" isRelative>
                <DiamondDetailLeft
                  data={this.data}
                  flags={this.state.flags}
                  activeTab={this.state.activeTab}
                  activeTabChange={(tab) => this.setState({ activeTab: tab })}
                  currentSubTab={(prev, current) => this.setState({ currentSubTab: current })}
                />
                <div className="d-flex j-content-center downloadCopyLink">
                  <div className="diamondDetailSperateBlock commonOutline" onClick={this.handleDownload}>
                    <DownloadIcon />
                    <span>&nbsp;Download</span>
                  </div>
                  <div className="diamondDetailSperateBlock commonOutline" onClick={this.handleCopyLink}>
                    <CopyLinkIcon />
                    <span>&nbsp;Copy Link</span>
                  </div>
                </div>
              </GridHeightContainer>
            </GridHeightContainer>
            <GridHeightContainer
              className={classNames(['diamondDetailRight', !this.props.diamondPopup && 'diamondDetailPage'])}
              subtractFrom=".diamondDetailInner > .diamondDetailBottomBox"
            >
              {!this.props.diamondPopup && (
                <div className="diamondDetailBottomBox">
                  <div className="diamondDetailBottomAction">
                    <div className="d-flex">
                      {user && user.account ? (
                        <>
                          {!this.props.noDetailAction && (
                            <>
                              <DiamondDetailAction
                                image={cartSvg}
                                tooltip="Place Order"
                                placement="bottomLeft"
                                onClick={() => {
                                  permission && permission.insert
                                    ? this.setState({ visible: true, detail: false, show: false, offer: false })
                                    : OpenNotification({ type: 'error', title: message });
                                }}
                              />

                              <DiamondDetailAction
                                image={addCartSvg}
                                tooltip="Add To Cart"
                                placement="bottomLeft"
                                onClick={() => {
                                  permission && permission.insert
                                    ? handleInsertTrack(TRACK_TYPES.CART, [this.data])
                                    : OpenNotification({ type: 'error', title: message });
                                }}
                              />
                              <DiamondDetailAction
                                image={watchDetailSvg}
                                tooltip="Add To Watchlist"
                                placement="bottomLeft"
                                onClick={() => {
                                  permission && permission.insert
                                    ? handleInsertTrack(TRACK_TYPES.WATCHLIST, [this.data])
                                    : OpenNotification({ type: 'error', title: message });
                                }}
                              />
                              <DiamondDetailAction
                                image={offerSvg}
                                tooltip="Apply Offer"
                                placement="bottomLeft"
                                onClick={() => {
                                  permission && permission.insert
                                    ? this.setState({ offer: true, visible: false, detail: false, show: false })
                                    : OpenNotification({ type: 'error', title: message });
                                }}
                              />
                            </>
                          )}
                          <DiamondDetailAction
                            onClick={() => window.open(`https://gia.edu/report-check?reportno=${this.data.rptNo}`)}
                            image={certificateSvg}
                            tooltip="Verify Certificate"
                            placement="bottomLeft"
                          />

                          <DiamondDetailAction
                            onClick={() => {
                              permission && permission.mailExcel
                                ? this.setState({ sendEmail: !this.state.sendEmail })
                                : OpenNotification({ type: 'error', title: message });
                            }}
                            image={xRaySvg}
                            tooltip="Share"
                            placement="bottomLeft"
                          />

                          <DiamondDetailAction
                            onClick={() => {
                              permission && permission.downloadExcel
                                ? this.setState({ visibleEmail: true })
                                : OpenNotification({ type: 'error', title: message });
                            }}
                            image={downloadZipSvg}
                            tooltip="Download Zip"
                            placement="bottomLeft"
                          />
                        </>
                      ) : (
                        <>
                          {window.location.search === '?direct-share' && (
                            <DiamondDetailAction
                              word="Buy Now"
                              tooltip="Buy Now"
                              placement="bottomLeft"
                              onClick={() =>
                                this.props.history.push({
                                  pathname: '/quick-signup',
                                  state: { id: this.state.diamondId },
                                })
                              }
                            />
                          )}

                          <DiamondDetailAction
                            word="Signin"
                            tooltip="Signin"
                            placement="bottomLeft"
                            onClick={() => this.props.history.push('/signin')}
                          />
                          <DiamondDetailAction
                            word="Register"
                            tooltip="Register"
                            placement="bottomLeft"
                            onClick={() => this.props.history.push('/signup')}
                          />
                        </>
                      )}
                    </div>
                  </div>
                </div>
              )}
              {this.state.show && (
                <EnquiryDetail
                  style={!this.props.diamondPopup ? { height: gridHeight, overflow: 'auto' } : { height: 'auto' }}
                  checked={[this.data]}
                  onCancel={this.popupClose}
                  onClose={this.props.onClose}
                />
              )}
              {this.state.visible && (
                <PlaceOrderDetail
                  style={this.props.diamondPopup ? { height: gridHeight, overflow: 'auto' } : { height: 'auto' }}
                  checked={[this.data]}
                  onCancel={this.popupClose}
                  onClose={this.props.onClose}
                />
              )}
              {this.state.offer && (
                <OfferOrder
                  style={this.props.diamondPopup ? { height: gridHeight, overflow: 'auto' } : { height: '100%' }}
                  checked={[this.data]}
                  onCancel={this.popupClose}
                  onClose={this.props.onClose}
                />
              )}
              <GridHeightContainer
                className="d-flex"
                subtractFrom=".diamondDetailRight .diamondDetailBottomBox,.diamondDetailInner > .diamondDetailBottomBox"
              >
                {this.state.detail && (
                  <div className="diamondDetailContent">
                    {Object.values(detailView).map((section, index) => (
                      <div key={index} className="diamondDetailMore">
                        <h2 className="detailSmallTitle">{section?.name}</h2>
                        <div className="diamondDetailMoreHalf">
                          {Object.values(groupBy(section?.data, 'part')).map((list) => {
                            return list.map((field, index) => {
                              return (
                                <ul key={index}>
                                  <li>
                                    <span>{field.label}</span>
                                    <span>
                                      {isFunction(field?.render)
                                        ? field?.render(this.data[field?.key], this.data)
                                        : field?.isFormat
                                        ? formatDecimal(this.data[field?.key])
                                        : this.data[
                                            field?.key === 'colNm'
                                              ? this.data.isFcCol
                                                ? 'fcColDesc'
                                                : 'colNm'
                                              : field?.key
                                          ]
                                        ? field.key === 'cutNm'
                                          ? show3Ex
                                            ? this.data[field?.key]
                                            : this.data[field?.key]
                                          : field.key === 'colNm' && this.data.isFcCol
                                          ? this.data.fcColDesc
                                          : this.data[field?.key]
                                        : '-'}
                                    </span>
                                  </li>
                                </ul>
                              );
                            });
                          })}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
                <GridHeightContainer
                  className="similarStoneBlock"
                  subtractFrom=".diamondDetailRight .diamondDetailBottomBox,.diamondDetailInner > .diamondDetailBottomBox"
                >
                  <Heading className="popupInnerTitle" title="Similar Stone"></Heading>
                  {this.data.id && <SimilarStone id={this.data.id} />}
                </GridHeightContainer>
              </GridHeightContainer>
            </GridHeightContainer>
          </div>
        </div>
        <CommonModal
          title={'Share by'}
          handleCancel={() => this.setState({ sendEmail: false })}
          visible={this.state.sendEmail}
          wrapClassName="diamondListinSidebar"
        >
          <ShareDropdown
            {...this.props}
            checked={[this.data]}
            onCloseSharePopup={() => this.setState({ sendEmail: false })}
          />
        </CommonModal>
        <CommonModal
          title={<IntlMessages id="app.Download" />}
          handleCancel={() => this.setState({ visibleEmail: false })}
          visible={visibleEmail}
          wrapClassName=""
        >
          <DownloadDropdown
            onCloseDownloadPopup={() => this.setState({ visibleEmail: false })}
            checked={[this.data]}
            {...this.props}
          />
        </CommonModal>
      </div>
    );
  }
}

export default compose(
  connect((state) => ({
    commonData: state.commonData,
  })),
  withMobile,
  withRouter,
)(DiamondDetail);
